import React from 'react';
import Icon from './info-solid.svg';
import styles from './InfoIcon.module.scss';

function InfoIcon(props) {
    const { className, onClick, title } = props;

    return <Icon className={[className, styles.InfoIcon].join(' ')} onClick={onClick} title={title} />;
}

export default InfoIcon;
